import { SvgIcon, SvgIconProps } from '@mui/material';

const CenteredMinimize = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5.80469" y="11.394" width="12.3916" height="1.5" fill="#424242" />
    </svg>
  </SvgIcon>
);

export default CenteredMinimize;
